Librarian.Cart.Item = new Class({
    //#region Properties

    //#region Identifiers

    contentid: 0,
    contenttype: 0,
    fileid: 0,
    groupid: 0,
    presid: 0,
    slideid: 0,
    linkid: 0,
    slidenumber: 0,
    itemnumber: 0,

    //#endregion

    //#region Counts

    slidecount: 0,
    itemcount: 0,
    pagecount: 0,
    filesize: 0,
    
    //#endregion

    //#region Other Properties

    fromWizard: false,
    ext: null,
    sourceext: null,
    name: null,
    filename: null,
    title: null,
    extrafields: null,
    parentfields: null,
    thumbnailid: null,
    flags: 0,
    // The URL to download and replace this file with on the server
    fileUrl: null,

    catType: Librarian.catType.file,
    catId: -1,

    //#endregion

    //#region Cart-specific Properties

    // Whether this item has been deleted or not
    deleted: false,
    duplicate: false,
    // The children items this item may have
    items: null,
    // How this item was added to the cart
    addType: null,
    originalAddType: null,
    // The section index that this item belongs to
    section: -1,

    //#endregion

    //#region VP-specific Properties

    prestype: Librarian.virtPresType.undefined,
    isslideshow: false,
    isshared: false,

    //#endregion

    //#region Editable Properties

    hasedits: false,
    editable: false,
    editsXML: null,
    editFileName: null,

    //#endregion

    //#region Rules Properties

    isDependent: false,
    isTrigger: false,
    isIntegrity: false,
    isOrdering: false,
    isGrouping: false,
    isMandatory: false,
    // What position this item is locked to in the cart, "Start" or "End"
    cartPosition: null,
    // Whether this was automatically added as the result of rules
    fromRules: false,

    rules: [],
    ruleItems: [],
    ruleGroup: -1,
    orderindex: -1,

    //#endregion

    //#endregion

    /*
     * Initializes a new instance of this Item and ensures that default data values are set
     */
    initialize: function(data) {
        // Store original data
        this.data = data;

        // Store the information given
        this.contentid = data.contentid || 0;
        this.contenttype = data.contenttype || 0;
        this.fileid = data.fileid || 0;
        this.groupid = data.groupid || 0;
        this.presid = data.presid || 0;
        this.slideid = data.slideid || 0;
        this.linkid = data.linkid || 0;
        this.flags = data.flags || 0;

        // If the number is < 0, use 0
        // If the number is > 0, keep it
        this.slidenumber = data.slidenumber ? Math.max(data.slidenumber, 0) : 0;
        this.itemnumber = data.itemnumber ? Math.max(data.itemnumber, 0) : 0;
        // If the count is < 0, use 1 (this is for files with no slides)
        this.slidecount = data.slidecount ? Math.max(data.slidecount, 1) : 1;
        this.itemcount = data.itemcount;
        if (data.pagecount)
            this.pagecount = data.pagecount;
        this.filesize = data.filesize || 0;

        this.isslideshow = !!data.isslideshow;
        this.isshared = !!data.isshared;
        this.deleted = !!data.deleted;
        this.duplicate = !!data.duplicate;

        this.hasedits = !!data.hasedits;
        this.editable = !!data.editable;
        if (typeof data.editsXML == "string")
            this.editsXML = data.editsXML;
        if (typeof data.editFileName == "string")
            this.editFileName = data.editFileName;

        // Store the group or file name and extension
        this.name = data.name || data.filename;
        this.filename = data.filename;
        this.title = data.title;
        this.ext = data.filetypeextension || data.ext || '';
        if (data.sourceext)
            this.sourceext = data.sourceext;

        this.extrafields = data.extrafields;
        this.parentfields = data.parentfields;

        if (data.thumbnailid)
            this.thumbnailid = data.thumbnailid;

        this.setAddType(data.addType);

        if (typeof data.section == "number")
            this.section = data.section;
        if (typeof data.prestype == "number")
            this.prestype = data.prestype;

        // Save the category that this is being added from
        if (data.catId >= 0)
            this.catId = data.catId;
        // Edge case for group rule items
        else if (data.catid >= 0)
            this.catId = data.catid;
        else {
            var hashData = Librarian.Utils.getHash().parseQueryString();
            if (hashData.catid && hashData.type) {
                this.catId = hashData.catid;
                this.catType = hashData.type;        
            }
        }

        // Set cat type
        if (typeof data.cattype == "number" || typeof data.catType == "number")
            this.catType = data.catType || data.cattype;

        // If there is a file name
        if (data.filename) {
            // And this is a global and we should show the global name, save that instead
            if ((this.groupid > 0) && !Librarian.cart.showGlobalFavoriteName)
                this.name = data.filename;

            // Or this is a my favorite and we should show the my favorite name, save that instead
            if ((this.presid > 0) && !Librarian.cart.showMyFavoriteName)
                this.name = data.filename;
        }

        // Rules Properties
        this.isDependent = !!data.isDependent;
        this.isTrigger = !!data.isTrigger;
        this.isIntegrity = !!data.isIntegrity;
        this.isOrdering = !!data.isOrdering;
        this.isGrouping = !!data.isGrouping;
        this.rules = data.rules || [];
        this.ruleItems = data.ruleItems || [];
        this.ruleGroup = data.ruleGroup || -1;
        if (data.orderindex >= 0)
            this.orderindex = data.orderindex;
        this.fromRules = !!data.fromRules;
        this.updateIsMandatory();
        this.updatePosition();

        // Keep track of items coming from wizards
        this.fromWizard = !!data.fromWizard;

        // Initialize the list of items
        this.items = new Librarian.Cart.List();
    },

    /*
     * Clears the list of children
     */
    destroy: function() {
        if (this.items) {
            this.items.clear();
            this.items = null;
        }
    },

    //#region Set Methods

    /*
     * Sets a child of this item to be deleted
     *
     * data - Data representing the child cart item to be marked as deleted
     */
    setItemDeleted: function(data) {
        // Sets a given child item deleted
        if (this.items)
            this.items.setItemDeleted(data);
    },

    /*
     * Sets how this item was added to the cart
     * Used to determine how things are displayed in MIXED view mode
     *
     * addType - Value representing how this item was originally added to the cart
     */
    setAddType: function(addType) {
        // If a valid addType was provided, save it
        if ((typeof addType != "undefined") && (addType != null) && (addType >= Librarian.Cart.addTypes.FILE)) {
            this.addType = addType;
            if (this.originalAddType == null)
                this.originalAddType = this.addType;
        }
    },

    /*
     * Sets the parent fields of the cart item
     * Also recalculates the isMandatory and cartPosition properties if the respective settings are enabled
     *
     * fields - The list of extra fields from this item's parent
     */
    setParentFields: function(fields) {
        this.parentfields = fields;
        this.updateIsMandatory();
        this.updatePosition();
    },

    //#endregion

    //#region Get Methods

    /*
     * Gets the list of child items that match the given options
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     * addType - The type of item to include - Optional, If specified this will force all items in the list into the specified type. If not specified, items will be added as they were added to the list
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getItems: function(includeDeleted, addType, includeDuplicates) {
        return this.items ? this.items.getItems(includeDeleted, addType, includeDuplicates) : [];
    },

    /*
     * Gets the count of the child items that match the given options
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getSize: function(includeDeleted, includeDuplicates) {
        var size = 0;
        if (this.items)
            size = this.items.getSize(includeDeleted, null, includeDuplicates);
        if (this.isslideshow && (size == 0))
            size = 1;

        return size;
    },

    /*
     * Gets the count of child items that match the given options
     * If this does not have any child items, this item's data is used to determine the count
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getCount: function(includeDeleted, includeDuplicates) {
        // If we are not told to include deleted items, assume not
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;
        // If we aren't told whether to include duplicated items, assume we shouldn't
        if ((typeof includeDuplicates == "undefined") || (includeDuplicates == null))
            includeDuplicates = true;

        // If this has no children, ignoring the given settings
        if (this.getSize() == 0) {
            // If this is a slide, return 1
            if ((this.slideid > 0) || (this.addType == Librarian.Cart.addTypes.SLIDE))
                return 1;

            // Otherwise return the slide count (Shouldn't ever happen)
            return Math.max(this.slidecount, 1);
        }

        // Return the number of slides this item has
        // that match the requested deleted and duplicate state
        return this.getSize(includeDeleted, includeDuplicates);
    },

    /*
     * Gets the item at the location specified by `index`
     *
     * index - The location in this list that the item is being retrieved from
     */
    getItem: function(index) {
        return this.items ? this.items.items[index] : null;
    },

    //#endregion

    //#region Boolean Methods

    /*
     * Determines whether this item equals the given data
     *
     * data - The data with which this is being compared for equality
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    equals: function(data, ignoreGroup) {
        return Librarian.Utils.isDataEqual(this, data);
    },

    /*
     * Determines whether this item is a child of the given parent item
     *
     * parentItem - The item against which this is being checked as a potential parent
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    isChildOf: function(parentItem, ignoreGroup) {
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;
        // If the parent isn't actually a parent,
        // this can't be its child
        if (parentItem.slidenumber > 0)
            return false;

        // If the given item is a parent item who is related to this item, it is this item's parent
        return this.isRelatedTo(parentItem, ignoreGroup);
    },

    /*
     * Determines whether this istem is the parent of a given child item
     */
    isParentOf: function(childItem) {
        // If this isn't actually a parent,
        // the child can't be its child
        if (this.slidenumber > 0)
            return false;

        // If this item is a parent item who is related to the given item, it is that item's parent
        return this.isRelatedTo(childItem);
    },

    /*
     * Determines whether this item is related to the given item
     *
     * item - The item against which this is being compared for relation
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    isRelatedTo: function(item, ignoreGroup) {
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;

        // If this isn't a group
        if (ignoreGroup || (this.groupid == 0)) {
            // Check if it's a virtual presentation
            if (!ignoreGroup && (this.presid != 0))
                return this.presid == item.presid;

            // If not, compare the file ids
            return this.fileid == item.fileid;
        }

        // Otherwise compare the group ids
        return this.groupid == item.groupid;
    },

    /*
     * Determines whether this item has the given item in its list of children
     *
     * item - The item which is being searched for within this item's list of children
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    contains: function(item, includeDeleted, ignoreGroup) {
        return this.items ? this.items.contains(item, includeDeleted, ignoreGroup) : false;
    },

    /*
     * Determines whether or not the given location has two items next to eachother in the same Rule Group
     *
     * index - The location at which to check for adjacent Rule Group items
     *
     * Returns true if this location has two rule group items next to eachother, false otherwise
     */
    isLocNextToRuleGroupItem: function(index) {
        if (!Librarian.userCart)
            return true;

        var targetItem = Librarian.userCart.getItem(index);
        // Only check grouping if we're dropping on an item that isn't in our group
        if (targetItem && targetItem.isGrouping && (targetItem.ruleGroup != this.ruleGroup)) {
            // Check if moving this item to this location will break the continuity of the group at the destination
            var prevItem = Librarian.userCart.getItem(index - 1);
            // If this is the previous item we are actually moving AFTER this item so we have to check the next item instead
            if (prevItem && prevItem.equals(this))
                prevItem = Librarian.userCart.getItem(index + 1);

            // If this item exists and its in the same group as the destination item then we're breaking the grouping rules
            if (prevItem && (prevItem.ruleGroup == targetItem.ruleGroup))
                return true;
        }
        return false;
    },

    /*
     * Determines whether or not this item has mandatory items in its rule group
     */
    hasMandatoryRuleChildren: function() {
        if (!Librarian.cart.enableGroupRules || (this.ruleGroup <= 0) || !Librarian.userCart)
            return false;

        return (Librarian.userCart.getMandatoryItems(this.ruleGroup) || []).length > 0;
    },

    //#endregion

    //#region Add/Remove

    /*
     * Adds the given item to this item's list of children
     *
     * item - Item to be added to this item's list
     * undelete - Whether to unmark the item for deletion if it already exists in this item's list of children
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    addItem: function(item, undelete, ignoreGroup) {
        if (!this.items)
            return;
        this.items.addItem(item, undelete, ignoreGroup);
    },

    /*
     * Removes the given item from this item's list of children
     *
     * item - Item to be removed from this item's list
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    removeItem: function(item, ignoreGroup) {
        if (!this.items)
            return;
        this.items.removeItem(item, ignoreGroup);
    },

    /*
     * Removes the children of the given item from this item's list of children
     *
     * item - Item whose children are to be removed from this item's list
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    removeItemChildren: function(item, ignoreGroup) {
        if (!this.items)
            return;
        this.items.removeItemChildren(item, ignoreGroup);
    },

    //#endregion

    //#region Rules

    /*
     * Handles logic of automatically adding rule-based items for Dependent Trigger and Integrity Group items
     * as well as positioning of Ordering Group, Grouping Group, and fixed position items
     *
     * insert - Whether or not this item was added as the result of an insert operation
     * update - Whether or not to run the update rules after completing this operation
     */
    onAdd: function(insert, update) {
        if (!Librarian.cart.enableGroupRules || !Librarian.userCart)
            return;

        var doPositioning = function(thisItem) {
                // If we're not inserting and this thing should be at the end, we're already done
                // New items are added to the end automatically
                if (!insert && (thisItem.cartPosition == "end"))
                    return;

                var itemIndex = Librarian.userCart.getItemIndex(thisItem);
                if (itemIndex < 0)
                    return;

                // If this item is already at the beginning then we're already done
                if ((itemIndex == 0) && (thisItem.cartPosition == "start"))
                    return;

                var cartItems = Librarian.userCart.getCartItems(true);
                // If this item is already at the end then we're already done
                if ((thisItem.cartPosition == "end") && (itemIndex == (cartItems.length - 1)))
                    return;

                // Remove this item from it's position in the list
                Librarian.userCart.cartItems.items.remove(itemIndex);

                // Move this item in front of the first item in the list
                if (thisItem.cartPosition == "start")
                    Librarian.userCart.cartItems.items.unshift(thisItem);
                // Move this item after the last item in the list
                else
                    Librarian.userCart.cartItems.items.push(thisItem);

                Librarian.Utils.notification(Librarian.Lang.getString("cart_moved_rules"));
                
            },
            doPositionedRules = function(thisItem) {
                if (!thisItem.isGrouping || !thisItem.isOrdering)
                    return;

                var ruleItems = Librarian.userCart.getRuleGroupItems(thisItem.ruleGroup);
                // Don't bother doing anything if this is the only item in its group in the cart
                if (ruleItems.length <= 1)
                    return;

                var sortByOrder = function(list) {
                        return list.sort(function(a, b) {
                            if (a.orderindex < b.orderindex)
                                return -1;
                            else if (a.orderindex > b.orderindex)
                                return 1;
                            return 0;
                        });
                    },
                    insertBefore = function(list) {
                        var thisIndex = Librarian.userCart.cartItems.indexOf(thisItem);
                        Librarian.userCart.cartItems.insertItemsAt(list, thisIndex);
                    },
                    insertAfter = function(list) {
                        var thisIndex = Librarian.userCart.cartItems.indexOf(thisItem);
                        Librarian.userCart.cartItems.insertItemsAt(list, thisIndex + 1);
                    },
                    getRulesLists = function(beforeList, afterList) {
                        // Sort each item in to the correct `before` or `after` list based on their position relative to this item
                        for (var i = Librarian.userCart.cartItems.items.length; i--;) {
                            var cartItem = Librarian.userCart.cartItems.items[i];
                            if (!cartItem || (cartItem.ruleGroup != thisItem.ruleGroup) || (cartItem.orderindex == thisItem.orderindex))
                                continue;

                            var remove = false;
                            // Add this item to the correct list
                            if (cartItem.orderindex < thisItem.orderindex) {
                                if (beforeList != null) {
                                    beforeList.push(cartItem);
                                    remove = true;
                                }
                            }
                            else if (afterList != null) {
                                afterList.push(cartItem);
                                remove = true;
                            }

                            // Remove this item from the cart list for now
                            if (remove)
                                Librarian.userCart.cartItems.items.remove(i);
                        }

                        // Sort these lists if everything should be in order
                        if (thisItem.isOrdering) {
                            if (beforeList)
                                beforeList = sortByOrder(beforeList);
                            if (afterList)
                                afterList = sortByOrder(afterList);
                        }
                    }

                // Apply grouping and ordering rules based on the fact that the newly added item cannot move but the other rules should still apply relative to it
                if (thisItem.isGrouping) {
                    var beforeItems = [],
                        afterItems = [];
                     getRulesLists(beforeItems, afterItems);

                    // Move these items to their correct position in the cart
                    insertBefore(beforeItems);
                    insertAfter(afterItems);
                }
                else {
                    var afterItems = [];
                    getRulesLists(null, afterItems);

                    // Move all the items with a higher order index after this item in the cart
                    insertAfter(afterItems);
                }
                Librarian.Utils.notification(Librarian.Lang.getString("cart_moved_rules"));
            },
            doOrdering = function(thisItem) {
                var cartItems = Librarian.userCart.getCartItems(true);
                // Find the first thing from this same group whose order index is greater than this one's
                for (var i = 0, length = cartItems.length; i < length; i++) {
                    var item = cartItems[i];
                    // Only check items that are in the same rule group
                    if (!item || (item.ruleGroup != thisItem.ruleGroup) || item.equals(thisItem, true))
                        continue;

                    // Find the first item that comes after this item and move this before it
                    if (item.orderindex > thisItem.orderindex) {
                        Librarian.userCart.moveItem(thisItem, item, update, true);
                        Librarian.Utils.notification(Librarian.Lang.getString("cart_moved_rules"));
                        return;
                    }
                }
            },
            doGrouping = function(thisItem) {
                var index = Librarian.userCart.getItemIndex(thisItem),
                    nextItem = Librarian.userCart.getItem(index + 1);

                // Check to make sure this item isn't already grouped
                if ((nextItem != null) && (nextItem.ruleGroup == thisItem.ruleGroup))
                    return;
                var prevItem = Librarian.userCart.getItem(index - 1);
                if ((prevItem != null) && (prevItem.ruleGroup == thisItem.ruleGroup))
                    return;

                var cartItems = Librarian.userCart.getCartItems(true);
                // Find the last thing that is a part of this group
                for (var i = cartItems.length; i--;) {
                    var item = cartItems[i];
                    // Only check items that are in the same rule group
                    if (!item || (item.ruleGroup != thisItem.ruleGroup) || item.equals(thisItem, true))
                        continue;

                    nextItem = Librarian.userCart.getItem(i + 1);
                    // If the next item doesn't exist or this is the next item, there's nothing for us to do here
                    if ((nextItem != null) && !nextItem.equals(thisItem)) {
                        Librarian.userCart.moveItem(thisItem, nextItem, update, true);
                        Librarian.Utils.notification(Librarian.Lang.getString("cart_moved_rules"));
                        return;
                    }
                }
            };

        // Do cart positioning of this item based on set meta before doing anything else
        if (this.cartPosition) {
            doPositioning(this);
            doPositionedRules(this);
        }
        else if (Librarian.cart.itemPositionMetaName) {
            // Apply positioning to items added after "end" items by moving them before the "end" items while also not breaking their grouping
            var endItems = Librarian.userCart.getPositionedItems("end", true);
            if (endItems.length > 0) {
                // Order of endItems matches the order from the cart, 100% of the time because "filter" is done using an in-order for loop
                var targetItem = endItems[0];

                // Don't break "grouping" rules if the target item has them
                if (targetItem.isGrouping) {
                    // Get the list of this group's items and save the first one as the target
                    var groupItems = Librarian.userCart.getGroupingItems(targetItem.ruleGroup, true);
                    if (groupItems.length > 0)
                        targetItem = groupItems[0];
                }

                var thisIndex = Librarian.userCart.getItemIndex(this),
                    targetIndex = Librarian.userCart.getItemIndex(targetItem);
                // If this item isn't already before the target item, move it
                if (thisIndex > targetIndex) {
                    Librarian.userCart.moveItem(this, targetItem, update, true);
                    Librarian.Utils.notification(Librarian.Lang.getString("cart_moved_rules"));
                }
            }
        }

        // Only run this rule check for dependent triggers and integrity group members that have content
        if ((this.isTrigger || this.isIntegrity) && (this.ruleItems.length > 0)) {
            var section = 0;

            var lastSection = Librarian.userCart.getLastSectionIndex();
            if (lastSection < 0)
                lastSection = null;

            // If we want to preserve grouping
            if (this.isGrouping) {
                section = this.section;
            }
            // Otherwise use the last section
            else {
                section = lastSection;
            }

            // Add each group member to the cart automatically
            var added = 0;
            for (var i = 0, length = this.ruleItems.length; i < length; i++) {
                var data = this.ruleItems[i];

                /* This doesn't make sense and causes the item to show up wrong. What was the intent?
                // Convert this item into a group item
                data.itemnumber = data.orderindex + 1;
                data.slidecount = this.ruleItems.length;
                data.sourceext = data.filetypeextension;
                data.ext = data.filetypeextension = "favg";
                data.name = data.groupname;
                */

                if (Librarian.userCart.isInCart(data, false, null, true))
                    continue;

                // Convert some properties to how the cart is expecting them
                data.isDependent = this.isDependent;
                data.isTrigger = this.isTrigger;
                data.isIntegrity = this.isIntegrity;
                data.isOrdering = this.isOrdering;
                data.isGrouping = this.isGrouping;
                data.rules = this.rules;
                data.fromRules = true;
                data.ruleGroup = data.groupid;
                delete data.groupid;

                // If this is a trigger slide, all items we're adding are dependents
                if (this.isTrigger) {
                    data.isDependent = true;
                    data.isTrigger = false;
                }

                var cartItem = Librarian.userCart.addToCartEx(data, null, true, section, true);
                // Only increase the counter if we successfully added to the cart
                if (cartItem != null) {
                    added++;

                    // If this is an integrity item, copy the rules items over so it can handle its own rules
                    if (this.isIntegrity)
                        cartItem.ruleItems = this.ruleItems;

                    // If the added item has a position set, make sure it is placed there
                    var position = Librarian.Cart.Item.getItemPosition(cartItem);
                    if (position) {
                        doPositioning(cartItem);
                        doPositionedRules(cartItem);
                    }
                    else {
                        // Make sure the added item is in correct ordering
                        if (cartItem.isOrdering)
                            doOrdering(cartItem);

                        // Don't bother calling this on add because everything is already grouped
                        if ((insert === true) && cartItem.isGrouping)
                            doGrouping(cartItem);
                    }
                }
            }

            // Notify the user that some slide were automatically added
            if (added > 0) {
                if (this.isOrdering)
                    Librarian.Utils.notification(Librarian.Lang.getPluralArgString("cart_added_moved_rules", added, added));
                else
                    Librarian.Utils.notification(Librarian.Lang.getPluralArgString("cart_added_rules", added, added));


                // Update the changeboxes outside the cart
                Librarian.Utils.updateAllCheckboxes();
            }
        }
        // Don't run the other rules when adding something with position rules because the position rules item needs to be the anchor around which everything else moves
        else if (!this.cartPosition) {
            if (this.isOrdering)
                doOrdering(this);
            if (this.isGrouping)
                doGrouping(this);
        }
    },

    /*
     * Determines whether this item can be inserted at the given location without breaking group rules
     *
     * Returns true if this is a valid location, false otherwise
     */
    canInsert: function(destLoc) {
        if (!Librarian.cart.enableGroupRules || !Librarian.userCart)
            return true;

        var targetItem = Librarian.userCart.getItem(destLoc);
        // Make sure the position we are putting this item obeys forced ordering
        if (this.isOrdering) {
            // Get the entire list of items so we can check the destination position relative to the actual location of each item in the cart
            var cartItems = Librarian.userCart.getCartItems(true);
            // Find the first thing from this same group whose order index is greater than this one's
            for (var i = 0, length = cartItems.length; i < length; i++) {
                var item = cartItems[i];
                // Only check items that are in the same rule group
                if (!item || (item.ruleGroup != this.ruleGroup) || item.equals(this, true))
                    continue;

                // If the found item should come after this item but the current position is before where we're trying to put this item,
                // that violates the Ordering of this group
                if ((this.orderindex > item.orderindex) && (i >= destLoc)) {
                    Librarian.Utils.error(Librarian.Lang.getString("cart_insert_fail"));
                    return false;
                }
            }
        }

        // Only bother checking grouping rules if there are other items in the cart in this same group
        if (this.isGrouping && Librarian.userCart.hasRuleGroupItem(this)) {
            var prev = destLoc - 1,
                found = false,
                isRuleItem = function(indexItem) {
                    // If this item exists and the group matches, this is a valid position
                    if ((indexItem != null) && (indexItem.ruleGroup == this.ruleGroup))
                        return true;
                    return false;
                }.bind(this);

            // If there is a previous item, check if it belongs to the same group
            if (prev >= 0) {
                if (isRuleItem(Librarian.userCart.getItem(prev)))
                    found = true;
            }

            // If the previous item wasn't valid, check if the next item belongs to the same group
            if (!found) {
                if (isRuleItem(targetItem))
                    found = true;
            }

            // If neither item on either side of the destination is in this group, grouping rules are violated
            if (!found) {
                Librarian.Utils.error(Librarian.Lang.getString("cart_insert_fail"));
                return false;
            }
        }

        // Only check the target item if there actually is one
        if (targetItem) {
            // If this item is not next to a rule group item we're breaking continuity
            if (this.isLocNextToRuleGroupItem(destLoc)) {
                Librarian.Utils.error(Librarian.Lang.getString("cart_insert_fail"));
                return false;
            }

            // Only check groups that actually have rules
            // It's OK to break apart basic, pdf, and pptx groups
            var hasRules = (targetItem.ruleGroup > 0) && ((targetItem.rules || []).length > 0),
                addType = targetItem.originalAddType;
            if (typeof addType != "number")
                addType = targetItem.addType;
            // If the cart is in slide view and the target is a file item inside a group, make sure doing this insert won't break the file apart
            if (Librarian.userCart.isInSlideView() && hasRules && (addType == Librarian.Cart.addTypes.FILE) && (targetItem.slidenumber > 1)) {
                Librarian.Utils.error(Librarian.Lang.getString("cart_insert_fail"));
                return false;
            }

            // Only check this logic if item positioning is enabled
            if (Librarian.cart.itemPositionMetaName) {
                var cartItems = null,
                    checkPosition = function(start, end, position) {
                        // Cache the list of cart items but only pull it if this method is called at least once
                        if (cartItems == null)
                            cartItems = Librarian.userCart.getCartItems(true);
                        // If we're not given a valid end, go to the end of the list
                        if (end < 0)
                            end = cartItems.length;

                        for (var idx = start; idx < end; idx++) {
                            var cartItem = cartItems[idx];
                            // Skip ones without position because we don't care where those are while doing this check
                            // We only care if we're before a "start" or after an "end"
                            if (!cartItem || !cartItem.cartPosition)
                                continue;

                            if (cartItem.cartPosition != position)
                                return false;
                        }

                        return true;
                    };

                // Items inserted before "start" and after "end" should be blocked
                if (!checkPosition(0, destLoc, "start") || !checkPosition(destLoc, -1, "end")) {
                    Librarian.Utils.error(Librarian.Lang.getString("cart_insert_fail"));
                    return false;
                }
            }
        }
        return true;
    },

    /*
     * Handles logic of automatically adding rule-based items for Dependent Trigger and Integrity Group items after insert
     * Also handles moving items with fixed positions after they are dropped into the cart
     */
    onInsert: function() {
        if (this.isTrigger || this.isIntegrity || this.cartPosition)
            this.onAdd(true);
    },

    /*
     * Determines whether this item can be moved to the given location without breaking group rules
     *
     * Returns true if this is a valid location, false otherwise
     */
    canMove: function(destItem) {
        if (!Librarian.cart.enableGroupRules || !Librarian.userCart)
            return true;

        var destLoc = Librarian.userCart.getItemIndex(destItem, true);
        if (this.isOrdering) {
            // Can't reorder ordering items within the same group
            if (destItem.ruleGroup == this.ruleGroup) {
                Librarian.Utils.error(Librarian.Lang.getString("cart_move_fail"));
                return false;
            }
            // Check if moving this item to this location will break this item's ordering
            // Allow a group with Ordering and Grouping to be moved because the onMove code will move the rest of the group with it
            else if ((destLoc >= 0) && !this.isGrouping) {
                var currLoc = Librarian.userCart.getItemIndex(this),
                    // Only get this group's items because we only care about where they are relative to eachother, we don't care about anything else in the cart
                    cartItems = Librarian.userCart.getRuleGroupItems(this.ruleGroup, true),
                    doCheck = function(idx, forward) {
                        var item = cartItems[idx];
                        // Don't check this same item
                        if (!item || item.equals(this, true))
                            return true;

                        // If the item at this location's order index is less than this item's order index, putting this item in front of it will violate group rules
                        if ((forward && (item.orderindex > this.orderindex)) || (item.orderindex < this.orderindex)) {
                            Librarian.Utils.error(Librarian.Lang.getString("cart_move_fail"));
                            return false;
                        }
                        return true;
                    }.bind(this);

                // If we're moving backwards in the cart, make sure the items with higher order index are all after this item
                if (currLoc < destLoc) {
                    for (var i = currLoc; i < destLoc; i++) {
                        if (!doCheck(i, true))
                            return false;
                    }
                }
                // Otherwise we're moving forwards and we need to make sure all items with lower order index are before this one
                else {
                    for (var i = destLoc; i < currLoc; i++)
                        if (!doCheck(i))
                            return false;
                }
            }
        }

        // Only check the target item if there actually is one
        if (destItem) {
            var thisLoc = Librarian.userCart.getItemIndex(this, true),
                checkLoc = destLoc;
            // If we're moving from before the current location then we need to check that we're not
            // breaking the NEXT location since this inserts after the `destItem`
            if (thisLoc < destLoc)
                checkLoc++;

            // If this item is not next to a rule group item we're breaking continuity
            if (this.isLocNextToRuleGroupItem(checkLoc)) {
                Librarian.Utils.error(Librarian.Lang.getString("cart_move_fail_target"));
                return false;
            }

            // Only check groups that actually have rules
            // It's OK to break apart basic, pdf, and pptx groups
            var hasRules = (destItem.ruleGroup > 0) && ((destItem.rules || []).length > 0),
                addType = destItem.originalAddType;
            if (typeof addType != "number")
                addType = destItem.addType;
            // If the cart is in slide view and the target is a file item inside a group, make sure doing this insert won't break the file apart
            if (Librarian.userCart.isInSlideView() && hasRules && (addType == Librarian.Cart.addTypes.FILE) && (destItem.slidenumber > 1)) {
                Librarian.Utils.error(Librarian.Lang.getString("cart_move_fail_target"));
                return false;
            }

            // Only check this logic if item positioning is enabled
            if (Librarian.cart.itemPositionMetaName) {
                var cartItems = null,
                    checkPosition = function(start, end, position, equals) {
                        // Cache the list of cart items but only pull it if this method is called at least once
                        if (cartItems == null)
                            cartItems = Librarian.userCart.getCartItems(true);

                        for (var idx = start; idx < end; idx++) {
                            var cartItem = cartItems[idx];
                            // Don't skip ones without position
                            // We need to make sure we're not moving a "start" before a non-"start" or an "end" after a non-"end"
                            if (!cartItem)
                                continue;

                            if ((equals && (cartItem.cartPosition == position)) ||
                                (!equals && (cartItem.cartPosition != position)))
                                return false;
                        }

                        return true;
                    };

                var canMove = true;
                // If either the current item or the destination item have a set position, make sure this move doesn't violate rules
                // If the positions are the same then allow them to move around eachother
                if (this.cartPosition && (this.cartPosition != destItem.cartPosition)) {
                    // Don't allow moving "end" before non-"end"
                    if (this.cartPosition == "end")
                        canMove = checkPosition(destLoc, thisLoc, this.cartPosition);
                    // Don't allow moving "start" after non-"start"
                    else
                        canMove = checkPosition(thisLoc + 1, destLoc + 1, this.cartPosition);
                }
                // Make sure moving this item doesn't violate the rules of other items in the cart
                else if (!this.cartPosition) {
                    // Don't allow moving non-"start" before "start"
                    canMove = checkPosition(destLoc, thisLoc, "start", true) &&
                        // or non-"end" after "end"
                        checkPosition(thisLoc + 1, destLoc + 1, "end", true);
                }

                // Report to the user if they cannot move this item and stop the move
                if (!canMove) {
                    Librarian.Utils.error(Librarian.Lang.getString("cart_move_fail_target"));
                    return false;
                }
            }
        }

        return true;
    },

    /*
     * Handles the logic of automatically moving Grouping Group items together while maintaining order
     */
    onMove: function(oldLoc) {
        if (!Librarian.cart.enableGroupRules || (oldLoc < 0) || !this.isGrouping || !Librarian.userCart || !Librarian.userCart.hasRuleGroupItem(this))
            return;

        // Get this item's index, if it doesn't have one then don't bother continuing
        var index = Librarian.userCart.getItemIndex(this);
        if (index < 0)
            return;

        // Get the next and previous item
        var prevItem = Librarian.userCart.getItem(index - 1),
            nextItem = Librarian.userCart.getItem(index + 1),
            found = false;

        // If there is a previous item check if it matches the same group as this item
        if (prevItem && (prevItem.ruleGroup == this.ruleGroup))
            found = true;

        // If there is a next item check if it matches the same group as this item
        if (!found && nextItem && (nextItem.ruleGroup == this.ruleGroup))
            found = true;

        // If neither the next nor previous item are in the same group, we need to move all group members into position
        if (!found) {
            var moved = 0,
                previousItems = [],
                nextItems = [],
                cartItems = Librarian.userCart.getCartItems(true),
                offset = 0;

            // If we're moving to a smaller location, increase the offset so we start in the right place
            if (index < oldLoc)
                offset = 1;

            // Find any item from the group from before the old location, those items will be inserted before the new location
            for (var i = (oldLoc + offset); i--;) {
                var item = cartItems[i];
                if (item && (item.ruleGroup == this.ruleGroup) && !item.equals(this)) {
                    cartItems.remove(i);
                    previousItems.push(item);
                }
            }

            // Find any item from the group from after the old location, those items will be inserted after the new location
            for (var i = (oldLoc + offset) - previousItems.length, length = cartItems.length; i < length; i++) {
                var item = cartItems[i];
                if (item && (item.ruleGroup == this.ruleGroup) && !item.equals(this)) {
                    cartItems.remove(i);
                    nextItems.push(item);
                    // Decrease the counter and length since we removed an item
                    i--;
                    length--;
                }
            }

            // If the new location is after the old location we need a negative offset for the items
            // so the location is correct when there are more grouped items than the index delta
            var beforeIndex = index,
                afterIndex = index + previousItems.length + offset;
            if (index > oldLoc) {
                // Adjust the index to compensate for the items that were removed to be moved to their correct locations
                beforeIndex -= (previousItems.length + nextItems.length);
                // Insert the items after the end of the previously added items and the item being dragged
                afterIndex = beforeIndex + previousItems.length + 1;
            }

            // Make sure these items are in the correct order before inserting them
            previousItems.sort(function(a, b) {
                if (a.orderindex < b.orderindex)
                    return -1;
                else if (a.orderindex > b.orderindex)
                    return 1;
                return 0;
            });

            // Insert all the items from before the old location before the new location as well
            Librarian.userCart.cartItems.insertItemsAt(previousItems, beforeIndex);
            moved += previousItems.length;
            // Insert all the items from after the old location after the new location as well
            Librarian.userCart.cartItems.insertItemsAt(nextItems, afterIndex);
            moved += nextItems.length;

            // If we moved anything, update the cart
            if (moved > 0) {
                // Fire onUpdate if it exists
                Librarian.userCart.onUpdate();

                Librarian.Cart.onChange();

                // And notify the user
                Librarian.Utils.notification(Librarian.Lang.getPluralArgString("cart_move_auto", moved, moved));
            }
        }
    },

    /*
     * Determines whether this item can be removed from the cart and calls the cart's doRemoveFromCart if it can
     *
     * fromCart - Whether this request is coming from within the cart itself. If true, the item is marked as deleted, otherwise the item is removed - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item to remove from the cart - Optional, defaults to false
     * update - Whether to run the update function after this operation is complete - Optional, defaults to true
     * fromRules - Whether to bypass the "allowed" checks because this is from group rules - Optional, defaults to false
     * onRemove - Callback which is called after the remove has completed - Optional
     * onRemoveFail - Callback which is called if remove failed - Optional
     */
    canRemove: function(fromCart, ignoreGroup, update, fromRules, onRemove, onRemoveFail) {
        var doRemove = function(removeAutomaticallyAddedItemsOnly, bypassPostRulesCheck) {
            if (Librarian.userCart)
                Librarian.userCart.doRemoveFromCart(this, fromCart, ignoreGroup, update, bypassPostRulesCheck, onRemove, removeAutomaticallyAddedItemsOnly);
        }.bind(this);

        // Don't bother prompting or checking if this is being removed by rules unless this is a mandatory item
        var runRules = !fromRules || this.isMandatory;
        if (!Librarian.cart.enableGroupRules || !runRules || !Librarian.userCart) {
            doRemove(false, fromRules);
            return;
        }

        // Update the checkboxes if the user decided to abort the removal
        var abortRemoval = function() {
                // Update cart checkboxes
                if (fromCart)
                    Librarian.Cart.onChange();

                Librarian.Utils.updateAllCheckboxes();
                if (typeof onRemoveFail == "function")
                    onRemoveFail();
            },
            prompt = null;

        var isMandatory = this.isMandatory || this.hasMandatoryRuleChildren();
        if (isMandatory) {
            var itemType = Librarian.Utils.getItemType(this),
                message = "cart_remove_mandatory_prompt";

            // If this is the mandatory item then show the "this is mandatory" prompt
            if (this.isMandatory) {
                if (itemType == "slide")
                    message = "cart_remove_mandatory_slide_prompt";
                else if (itemType == "item")
                    itemType = "file";
            }
            // Otherwise this prompt is coming from a rule group
            else
                itemType = "group";

            // Prompt the removal of mandatory slides
            prompt = new Librarian.ConfirmWindow({
                id: this.fileid + "-" + this.slideid + "-mandatory-confirm",
                question: Librarian.Lang.getArgString(message, Librarian.Lang.getString(itemType).toLowerCase()),
                title: Librarian.Lang.getString("cart_remove_title"),
                height: 100,
                width: 525,
                resize: false,
                defaultButton: 2
            });
            prompt.onFirstButtonClicked = Librarian.Cart.doClear;
            prompt.onSecondButtonClicked = abortRemoval;
        }
        else if (this.isIntegrity) {
            // Prompt for removal if outside the cart
            if (!fromCart) {
                // Prompt the removal of integrity slides
                prompt = new Librarian.ConfirmWindow({
                    id: this.ruleGroup + "-" + this.slideid + "-integrity-confirm",
                    question: Librarian.Lang.getString("cart_remove_integrity_prompt"),
                    title: Librarian.Lang.getString("cart_remove_title"),
                    height: 100,
                    width: 500,
                    resize: false,
                    defaultButton: 2
                });
                prompt.onFirstButtonClicked = doRemove.pass([false, fromRules]);
                prompt.onSecondButtonClicked = abortRemoval;
            }
        }
        else if (this.isDependent) {
            // Prompt for removal if outside the cart
            if (!fromCart) {
                var triggerSlides = Librarian.userCart.getTriggerItems(this.ruleGroup);
                // Prompt the removal of the trigger slides if there are any
                if (triggerSlides.length > 0) {
                    prompt = new Librarian.ConfirmWindow({
                        id: this.ruleGroup + "-" + this.slideid + "-dependent-confirm",
                        question: Librarian.Lang.getString("cart_remove_trigger_prompt"),
                        title: Librarian.Lang.getString("cart_remove_title"),
                        height: 100,
                        width: 500,
                        resize: false,
                        defaultButton: 2
                    });
                    prompt.onFirstButtonClicked = doRemove.pass([false, fromRules]);
                    prompt.onSecondButtonClicked = abortRemoval;
                }
            }
        }
        else if (this.isTrigger) {
            // Prompt for removal if there is only 1 trigger left
            var triggerSlides = Librarian.userCart.getTriggerItems(this.ruleGroup);
            if (triggerSlides && (triggerSlides.length <= 1)) {
                prompt = new Librarian.ConfirmWindow({
                    id: this.ruleGroup + "-" + this.slideid + "-trigger-confirm",
                    question: Librarian.Lang.getString("cart_remove_dependent_prompt"),
                    title: Librarian.Lang.getString("cart_remove_title"),
                    height: 170,
                    width: 500,
                    resize: false,
                    useThirdButton: true,
                    useFourthButton: true,
                    firstButtonText: Librarian.Lang.getString("yes"),
                    secondButtonText: Librarian.Lang.getString("yes_all"),
                    thirdButtonText: Librarian.Lang.getString("no"),
                    fourthButtonText: Librarian.Lang.getString("cancel"),
                    defaultButton: 4
                });
                // Remove this item and all items that came along the item
                prompt.onFirstButtonClicked = doRemove.pass([true, fromRules]);
                // Remove this item and all items belonging to the same Rule Id
                prompt.onSecondButtonClicked = doRemove.pass([false, fromRules]);
                // Remove this item but do not remove related items; set fromRules = false to bypass post remove rules
                prompt.onThirdButtonClicked = doRemove.pass([false, true]);
                prompt.onFourthButtonClicked = abortRemoval;
            }
        }

        // Prompt before removing the item
        if (prompt) {
            prompt.show();
            return;
        }

        doRemove(false, fromRules);
    },

    /*
     * Handles logic of automatically removing rule-based items for Dependent, Trigger and Integrity Group items after removal
     *
     * fromCart - Whether this request is coming from within the cart itself. If true, the item is marked as deleted, otherwise the item is removed - Optional, defaults to false
     * removeAutomaticallyAddedItemsOnly - Used by the post remove rules to determine whether or not to only remove items that were added automatically
     */
    onRemove: function(fromCart, removeAutomaticallyAddedItemsOnly) {
        if (!Librarian.cart.enableGroupRules || !Librarian.userCart)
            return;

        var removeSlideList = function(type, filter, notify) {
            // Find all the items for this type
            var list = Librarian.userCart["get" + type.toCapitalCase() + "Items"](this.ruleGroup);
            // Filter items unless we're told not to
            if (filter !== false) {
                list = list.filter(function(item) {
                    return item.fromRules;
                });
            }

            if (list.length > 0) {
                // Remove them all
                for (var i = 0, len = list.length; i < len; i++)
                    Librarian.userCart.doRemoveFromCart(list[i], fromCart, null, true, true);

                // If within cart and we're not told to not notify, notify that these items were removed
                if (fromCart && (notify !== false)) {
                    Librarian.Utils.notification(Librarian.Lang.getString("cart_remove_" + type + "_notify"));
                }
                    
                // Refresh cart
                Librarian.Cart.onChange();
            }
        }.bind(this);

        // On removal of items under forced integrity when a group item is removed...
        if (this.isIntegrity)
            removeSlideList("integrity", false);
        // If there are no more triggers, remove the dependent items as well
        else if (this.isTrigger) {
            var triggerSlides = Librarian.userCart.getTriggerItems(this.ruleGroup);
            if (triggerSlides && (triggerSlides.length <= 0)) {
                if (removeAutomaticallyAddedItemsOnly)
                    removeSlideList("dependent", true, false);
                else
                    removeSlideList("dependent", false);
            }
        }
        // If this is a dependent that was removed, remove all the triggers
        else if (this.isDependent)
            removeSlideList("trigger", false);
    },

    //#endregion

    //#region Updates

    /*
     * Updates the duplicate state of all the items in this item's list of children
     */
    updateDuplicateState: function() {
        if (!this.items)
            return;
        this.items.updateDuplicateState();
    },

    /*
     * Updates the property that determines whether an item is mandatory in the cart
     * If the item does not have a value explicitly set then it will default to the parent's value, if that is available
     */
    updateIsMandatory: function() {
        if (!Librarian.cart.enableGroupRules || !Librarian.cart.mandatoryItemMetaName)
            return;

        var itemValue = this.extrafields && this.extrafields[Librarian.cart.mandatoryItemMetaName],
            parentValue = this.parentfields && this.parentfields[Librarian.cart.mandatoryItemMetaName];

        this.isMandatory = (itemValue == "true") ||
                           ((itemValue == '') && (parentValue == "true"));
    },

    /*
     * Updates the property that determines where an item must stay within the cart
     * If the item does not have a value explicitly set then it will default to the parent's value, if that is available
     */
    updatePosition: function() {
        this.cartPosition = Librarian.Cart.Item.getItemPosition(this);
    }

    //#endregion
});

Librarian.Cart.Item.extend({
    /*
     * Converts the given item into a file-level cart item
     */
    makeParent: function(data) {
        var parentItem = new Librarian.Cart.Item(data);

        // Change this item into a probable parent
        // That means the slide number is 0
        parentItem.slidenumber = 0;
        // and the slide ID is 0
        parentItem.slideid = 0;
        // and there is no item number either
        parentItem.itemnumber = 0;
        // If this data has a file name, use that as the "name" of this item
        if (data.filename)
            parentItem.name = data.filename;

        return parentItem;
    },

    /*
     * Gets the property that determines where an item must stay within the cart
     * If the item does not have a value explicitly set then it will default to the parent's value, if that is available
     */
    getItemPosition: function(data) {
        if (!Librarian.cart.enableGroupRules || !Librarian.cart.itemPositionMetaName)
            return null;

        var itemValue = ((data.extrafields && data.extrafields[Librarian.cart.itemPositionMetaName]) || '').trim().toLowerCase(),
            parentValue = ((data.parentfields && data.parentfields[Librarian.cart.itemPositionMetaName]) || '').trim().toLowerCase();

        if (itemValue.length > 0)
            return itemValue;
        else if (parentValue.length > 0)
            return parentValue;
        return null;
    }
});